<!--
    描述：考核系统 --- 考核规则 --- 新增规则
    时间：2021-03-04
    Created by 王帅
-->
<template>
    <div class="rules-detail-main">
        <el-form
            ref="rulesForm"
            :model="rulesForm"
            :rules="detailRules"
            size="medium"
            label-width="120px"
        >
            <el-row>
                <el-col :span="6">
                    <el-form-item label="规则编号" prop="code">
                        <el-input
                            v-model="rulesForm.code"
                            placeholder="请输入规则编号"
                            clearable
                            :disabled="routeQuery.type === 'view'"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="规则名称" prop="sname">
                        <el-input
                            v-model="rulesForm.sname"
                            placeholder="请输入规则名称"
                            clearable
                            :disabled="routeQuery.type === 'view'"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="版本" prop="version">
                        <el-input
                            v-model="rulesForm.version"
                            placeholder="请输入版本"
                            clearable
                            :disabled="routeQuery.type === 'view'"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="备注" prop="remark">
                        <el-input
                            v-model="rulesForm.remark"
                            placeholder="请输入备注"
                            :maxlength="200"
                            show-word-limit
                            clearable
                            :disabled="routeQuery.type === 'view'"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <!-- nav -->
        <div class="info-nav">
            <span class="info-title">考核规则</span>
            <span
                >考核类型：<i class="color-blue">{{ routeInfo.markObjName }}</i></span
            >
            <el-divider class="divider" direction="vertical"></el-divider>
            <span
                >考核人主体类型：<i class="color-blue">{{ routeInfo.judgeRoleName }}</i></span
            >
            <el-divider class="divider" direction="vertical"></el-divider>
            <span
                >被考核人主体类型：<i class="color-blue">{{
                    routeInfo.beJudgeRoleName
                }}</i></span
            >
        </div>

        <!-- 内容 -->
        <div
            class="rules-detail-content"
            :class="[
                { 'is-setting': rulesTable.setting },
                { 'is-onlyRead': rulesTable.showMode },
            ]"
        >
            <!-- 没有数据的情况下 显示新增按钮 -->
            <el-button
                class="btn-blue"
                icon="el-icon-plus"
                @click="addRules"
                v-if="rulesTable.tableData.length === 0"
                >新建考核规则</el-button
            >

            <!-- 否则显示表格 -->
            <template v-else>
                <!-- 未设置的 情况下 -->
                <template v-if="!rulesTable.setting">
                    <el-row :gutter="20" class="table-content">
                        <el-col class="h100" :span="20">
                            <vxe-table
                                ref="rulesTable"
                                :data="rulesTable.tableData"
                                :loading="rulesTable.loading"
                                :border="rulesTable.border"
                                :resizable="rulesTable.resizable"
                                :size="rulesTable.size"
                                :height="rulesTable.height"
                                highlight-current-row
                                highlight-hover-row
                                auto-resize
                                show-overflow="tooltip"
                                show-header-overflow="tooltip"
                                :edit-config="{ trigger: 'dblclick', mode: 'cell' }"
                                @edit-actived="onEdit"
                                @edit-closed="onEditClosed"
                                :span-method="mergeRowMethod"
                            >
                                <vxe-table-column
                                    type="seq"
                                    title="序号"
                                    width="60"
                                    align="center"
                                ></vxe-table-column>
                                <vxe-table-column
                                    v-for="(item, index) in rulesColumns"
                                    :key="item.prop"
                                    :field="item.prop"
                                    :title="item.title"
                                    :min-width="item.minWidth"
                                    :width="item.width"
                                    :align="item.align"
                                    :header-align="item.headerAlign"
                                    :edit-render="item.editRender"
                                >
                                    <template v-slot="{ row }" v-if="item.needRender">
                                        <span>{{ item.function(row[item.prop]) }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </el-col>
                        <el-col :span="4">
                            <p>
                                <el-button class="btn-blue" @click="onSetScore"
                                    >设置评分</el-button
                                >
                            </p>
                            <p>
                                <el-button
                                    class="mt10 btn-black"
                                    @click="doBack('backSelect')"
                                    >返回重选</el-button
                                >
                            </p>
                        </el-col>
                    </el-row>
                </template>

                <!-- 设置的情况下 -->
                <template v-else>
                    <div class="setting-header clearfix" v-show="!rulesTable.showMode">
                        <span class="fl"
                            >评价总分：<i class="color-blue">{{ setTotal }}</i> 分</span
                        >
                        <el-button
                            class="ml10 btn-blue"
                            size="small"
                            v-if="routeQuery.type !== 'view' && !rulesTable.showMode"
                            @click="doEditScore"
                            >修改总分</el-button
                        >
                        <span class="fr"
                            >合计单项满分值：<i class="color-blue">{{ sumTotal }}</i>
                            分</span
                        >
                    </div>
                    <div class="table-content" :class="{'mt10': rulesTable.showMode}">
                        <div>
                            <vxe-table
                                ref="rulesTable"
                                :data="rulesTable.tableData"
                                :loading="rulesTable.loading"
                                :border="rulesTable.border"
                                :resizable="rulesTable.resizable"
                                :size="rulesTable.size"
                                :height="rulesTable.height"
                                highlight-current-row
                                highlight-hover-row
                                auto-resize
                                show-overflow="tooltip"
                                show-header-overflow="tooltip"
                                @edit-closed="onEditClosed"
                                :span-method="mergeRowMethod"
                            >
                                <vxe-table-column
                                    type="seq"
                                    title="序号"
                                    width="60"
                                    align="center"
                                ></vxe-table-column>
                                <vxe-table-column
                                    v-for="(item, index) in rulesColumns"
                                    :key="item.prop"
                                    :field="item.prop"
                                    :title="item.title"
                                    :min-width="item.minWidth"
                                    :width="item.width"
                                    :align="item.align"
                                    :header-align="item.headerAlign"
                                    :edit-render="item.editRender"
                                >
                                    <template v-slot="{ row }">
                                        <!-- 如果需要渲染 -->
                                        <span v-if="item.needRender">{{
                                            item.function(row[item.prop])
                                        }}</span>

                                        <!-- 如果是 单项满分值 -->
                                        <vxe-input
                                            v-else-if="item.prop === 'singleScore'"
                                            type="number"
                                            min="0"
                                            :disabled="rulesTable.showMode"
                                            v-model="row.singleScore"
                                        ></vxe-input>

                                        <!-- 如果是 备注 -->
                                        <vxe-input
                                            v-else-if="item.prop === 'remark'"
                                            :disabled="rulesTable.showMode"
                                            v-model="row.remark"
                                            maxlength="50"
                                            show-word-count
                                            placeholder="请输入评分注意事项，不超过50个字"
                                        ></vxe-input>

                                        <!-- 如果是 受托单位申报分值 -->
                                        <vxe-input
                                            v-else-if="item.prop === 'declareScore'"
                                            type="number"
                                            min="0"
                                            :disabled="rulesTable.showMode"
                                            placeholder="请输入考核分值"
                                            v-model="row.declareScore"
                                        ></vxe-input>

                                        <!-- 如果是 审计中心考核分值 -->
                                        <vxe-input
                                            v-else-if="item.prop === 'assessScore'"
                                            type="number"
                                            min="0"
                                            :disabled="rulesTable.showMode"
                                            placeholder="请输入考核分值"
                                            v-model="row.assessScore"
                                        ></vxe-input>

                                        <span v-else>{{ row[item.prop] }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </div>

                        <!-- 说明 -->
                        <div class="setting-text">
                            <!-- 编辑模式 -->
                            <template v-if="!rulesTable.showMode">
                                <p>单项满分值值说明：</p>
                                <p>
                                    1、系统根据选择项数目，满分100分自动除，得到默认平均分值；
                                </p>
                                <p>
                                    2、默认单项满分值保留一位小数，小数点后1位。最后一项用100减去前面分值之和；
                                </p>
                                <p>3、默认单项满分值合计必须正好等于满分。</p>
                            </template>

                            <!-- 查看模式 -->
                            <template v-else>
                                <el-row>
                                    <el-col :span="20">
                                        <!-- <p class="show-total">总分：</p> -->
                                        <p class="show-total">总分： {{ setTotal }}分</p>
                                        <p>
                                            合计评分：<span class="text-border"></span>
                                            <!-- 合计评分：<span class="text-border">{{
                                                sumTotal
                                            }}</span> -->
                                            考核结果：<span class="text-border"></span>
                                        </p>
                                        <p>{{ resultText }}</p>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-button
                                            class="btn-blue"
                                            v-if="routeQuery.type !== 'view'"
                                            @click="doBack('backEditRules')"
                                            >修改考核规则</el-button
                                        >
                                    </el-col>
                                </el-row>
                            </template>
                        </div>

                        <!-- 评分 -->
                        <div class="setting-score" v-show="!rulesTable.showMode">
                            <h3>设置考核结果</h3>
                            <p
                                v-for="(item, index) in markResult"
                                :key="'考核结果' + index"
                                :class="{'is-error': item.isError}"
                            >
                                {{ item.title }}： 分值区间为
                                <el-input-number
                                    size="small"
                                    class="input-width"
                                    :min="0"
                                    :max="setTotal"
                                    step-strictly
                                    controls-position="right"
                                    :disabled="index === 0"
                                    @blur="onChangeMark('min', item, index)"
                                    v-model.number="item.min"
                                ></el-input-number>
                                ~
                                <el-input-number
                                    size="small"
                                    :min="0"
                                    :max="setTotal"
                                    step-strictly
                                    class="input-width"
                                    controls-position="right"
                                    :disabled="item.type === 3"
                                    @blur="onChangeMark('max', item, index)"
                                    v-model.number="item.max"
                                ></el-input-number>
                            </p>
                        </div>
                    </div>
                    <div
                        class="rules-detail-footer text-center"
                        v-show="rulesTable.setting && !rulesTable.showMode"
                    >
                        <el-button class="btn-black" @click="doBack('backSetting')"
                            >返回</el-button
                        >
                        <el-button class="btn-blue" @click="onSetRules"
                            >生成考核规则</el-button
                        >
                    </div>
                </template>
            </template>
        </div>

        <!-- 提交、取消按钮 -->
        <div class="special-btn-groups" v-if="routeQuery.type !== 'view'">
            <el-button size="small" class="btn-black" @click="doBack('backPage')"
                >取消</el-button
            >
            <el-button
                size="small"
                class="btn-blue"
                @click="doSubmit"
                :loading="saveLoading"
                :disabled="!rulesTable.canSave"
                >提交</el-button
            >
        </div>

        <!-- 弹窗 -->
        <el-dialog
            :visible.sync="dialogObj.visible"
            :width="dialogObj.width"
            :title="dialogObj.title"
            :fullscreen="dialogObj.fullscreen"
            center
            class="add-dialog"
            :close-on-click-modal="false"
        >
            <!-- 如果是选择考核项弹窗 -->
            <template v-if="dialogObj.module === 'select'">
                <div class="info-nav">
                    <span class="info-title">考核规则</span>
                    <span
                        >考核类型：<i class="color-blue">{{
                            routeInfo.markObjName
                        }}</i></span
                    >
                    <el-divider class="divider" direction="vertical"></el-divider>
                    <span
                        >考核人主体类型：<i class="color-blue">{{
                            routeInfo.judgeRoleName
                        }}</i></span
                    >
                    <el-divider class="divider" direction="vertical"></el-divider>
                    <span
                        >被考核人主体类型：<i class="color-blue">{{
                            routeInfo.beJudgeRoleName
                        }}</i></span
                    >
                </div>

                <!-- 选择列表 -->
                <vxe-table
                    ref="selectTable"
                    :data="selectTable.tableData"
                    :loading="selectTable.loading"
                    :border="selectTable.border"
                    :resizable="selectTable.resizable"
                    :size="selectTable.size"
                    :height="selectTable.height"
                    highlight-current-row
                    highlight-hover-row
                    auto-resize
                    show-overflow="tooltip"
                    show-header-overflow="tooltip"
                >
                    <vxe-table-column
                        type="checkbox"
                        width="60"
                        align="center"
                    ></vxe-table-column>
                    <vxe-table-column
                        type="seq"
                        title="序号"
                        width="60"
                        align="center"
                    ></vxe-table-column>
                    <vxe-table-column
                        v-for="(item, index) in activeColumns"
                        :key="item.prop + index"
                        :field="item.prop"
                        :title="item.title"
                        :min-width="item.minWidth"
                        :width="item.width"
                        :align="item.align"
                        :header-align="item.headerAlign"
                    >
                        <template v-slot="{ row }" v-if="item.needRender">
                            <span>{{ item.function(row[item.prop]) }}</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </template>

            <!-- 修改总分弹窗 -->
            <template v-if="dialogObj.module === 'score'">
                <el-form
                    ref="scoreForm"
                    :model="scoreForm"
                    size="medium"
                    label-width="70px"
                >
                    <el-row class="mt20">
                        <el-col :span="20" :offset="2">
                            <el-form-item label="原分值">
                                <el-input
                                    size="small"
                                    type="number"
                                    disabled
                                    :value="setTotal"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="20" :offset="2">
                            <el-form-item
                                label="调整为"
                                prop="newScore"
                                required
                                :show-message="false"
                            >
                                <el-input-number
                                    size="small"
                                    class="w100"
                                    controls-position="right"
                                    :precision="0"
                                    v-model.number="scoreForm.newScore"
                                ></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="20" :offset="2">
                            <el-form-item label="" prop="oldScore">
                                <span class="color-blue font-12"
                                    >提示：总分修改后，单项分填写合计需要等于修改后的总分值。</span
                                >
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </template>

            <!-- footer 组件 -->
            <div slot="footer" class="pdb10 text-center">
                <el-button size="small" class="btn" @click="dialogObj.visible = false"
                    >取 消
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    class="btn btn-blue"
                    @click="doSave"
                    >确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as Api from "api/evaluateManage/EvaluateRules.js";
import { $deepCopy } from 'utils/tools'
export default {
    data() {
        return {
            // 规则表单
            rulesForm: {
                sname: "",
                code: "",
                version: "",
                remark: "",
            },
            detailRules: {
                sname: [
                    {
                        required: true,
                        message: "请输入规则编号",
                        trigger: "blur",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "请输入规则名称",
                        trigger: "blur",
                    },
                ],
                version: [],
                remark: [],
            },
            rulesTable: {
                tableData: [],
                loading: false,
                border: true,
                resizable: true,
                size: "small",
                height: "auto",
                setting: false, // 开始设置
                showMode: false, // 展示模式
                canSave: false, // 可以保存
            },
            // 考核结果数组
            markResult: [
                {
                    type: 0, // 0.差评 1.良好 2.优秀 3.完美
                    min: 0,
                    max: 59,
                    isError: false,
                    title: "差评",
                },
                {
                    type: 1, // 0.差评 1.良好 2.优秀 3.完美
                    min: 60,
                    max: 79,
                    isError: false,
                    title: "良好",
                },
                {
                    type: 2, // 0.差评 1.良好 2.优秀 3.完美
                    min: 80,
                    max: 94,
                    isError: false,
                    title: "优秀",
                },
                {
                    type: 3, // 0.差评 1.良好 2.优秀 3.完美
                    min: 95,
                    max: 100,
                    isError: false,
                    title: "完美",
                },
            ],
            // 弹窗对象
            dialogObj: {
                visible: false,
                width: "80%",
                title: "新增",
                type: "add",
                fullscreen: false,
                module: "select",
            },
            // 选择评分项表格对象
            selectTable: {
                tableData: [],
                loading: false,
                border: true,
                resizable: true,
                size: "small",
                height: "525px",
            },
            // 调整总分
            scoreForm: {
                newScore: 0,
            },
            saveLoading: false, // 按钮等待状态
            setTotal: 100, // 设置的总分
            curTypeName: '',    // 编辑前的 类别名称
        };
    },
    created() {
        // 如果是编辑下 有数据 直接回显
        if (this.$getSessionItem("evaluateInfo")) {
            let params = JSON.parse(this.$getSessionItem("evaluateInfo"));
            // console.log(params);
            this.rulesForm = {
                sname: params.sname,
                code: params.code,
                version: params.version,
                remark: params.remark,
                id: params.id,
            };
            // 规则表格相关
            this.rulesTable.tableData = params.details;
            this.rulesTable.setting = true;

            // 评分详细
            this.markResult = JSON.parse(params.markResult);

            // 总分
            this.setTotal = parseInt(params.totalScore);

            this.routeQuery.type === "view" ? (this.rulesTable.showMode = true) : "";
        }
        // 初始获取评分项
        this.getScoreItems();
    },
    methods: {
        ...mapActions("app", ["setIsBack"]),
        // 获取考核项
        getScoreItems() {
            Api.getItemsData({ ruleId: this.routeQuery.ruleId })
                .then((res) => {
                    if (res.operationCode === 1) {
                        this.selectTable.tableData = res.data;
                    }
                })
                .catch((err) => {});
        },

        // 点击新增规则
        addRules() {
            this.dialogObj.visible = true;
            this.dialogObj.type = "add";
            this.dialogObj.module = "select";
            this.dialogObj.title = "选择考核项";
        },

        // 弹窗点击保存
        doSave() {
            this.dialogObj.btnLoading = true;
            switch (this.dialogObj.module) {
                // 选择考核项
                case "select":
                    let arr = this.$refs.selectTable.getCheckboxRecords();
                    this.rulesTable.tableData = arr;
                    break;
                case "score":
                    console.log(this.scoreForm.newScore)
                    if (
                        this.scoreForm.newScore &&
                        parseFloat(this.scoreForm.newScore) !== 0 &&
                        this.scoreForm.newScore !== ""
                    ) {
                        this.setTotal = this.scoreForm.newScore;
                        // 同时修改完美评分
                        this.markResult.find(
                            (x) => x.type === 3
                        ).max = this.scoreForm.newScore;
                    } else {
                        this.$message.warning("请填写修改后的总分值!");
                        this.dialogObj.btnLoading = false;
                        return;
                    }
                    break;
            }

            this.dialogObj.btnLoading = false;
            this.dialogObj.visible = false;
        },

        // 通用行合并函数（将相同多列数据合并为一行）
        mergeRowMethod({ row, _rowIndex, column, visibleData }) {
            // 定义要合并的 列 属性数组
            const fields = ["typeName"];
            const compareField = "itemType";
            const typeValue = row[compareField];
            // 如果是 合并的那列 且 要比较的值有数据
            if (typeValue && fields.includes(column.property)) {
                // 上一行
                const prevRow = visibleData[_rowIndex - 1];
                // 下一行
                let nextRow = visibleData[_rowIndex + 1];

                // 如果上一行存在 且 数据和当前行相同
                if (prevRow && prevRow[compareField] === typeValue) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow[compareField] === typeValue) {
                        nextRow = visibleData[++countRowspan + _rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            }
        },

        // 开始编辑类别
        onEdit({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) {
            this.curTypeName = row.typeName
        },

        // 编辑类别
        onEditClosed({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) {
            let that = this
            let _exist = this.rulesTable.tableData.find(x => that.spaceFilter(x.typeName) === that.spaceFilter(row.typeName) && x.itemId !== row.itemId)
            if (_exist) {
                row.typeName = this.curTypeName
                this.$message.warning('已经存在该类名，请重新编辑!')
                return
            }
            let _list = this.rulesTable.tableData.filter(
                (x) => x.itemType === row.itemType
            );
            _list.map((x) => {
                x.typeName = row.typeName;
            });
        },

        // 点击设置评分
        onSetScore() {
            this.rulesTable.setting = true;
            this.rulesTable.height = "auto";
        },

        // 设置考核规则
        onSetRules() {
            let status = true
            this.markResult.map(x => x.isError = false)
            // 判断考核结果是否有空值
            let _isEmpty = this.markResult.find(x => x.min === '' || x.max === '')
            if (_isEmpty) {
                _isEmpty.isError = true
                this.$message.info('请填写考核结果！')
                return
            }

            // 判断考核结果设置是否有误
            let _isSmall = this.markResult.find(x => parseFloat(x.max) < parseFloat(x.min))
            if (_isSmall) {
                _isSmall.isError = true
                this.$message.info('评分值设置有误，请重新设置！')
                return
            }

            // 判断评分区间是否齐全
            if (!this.isFull) {
                this.$message.info('评分值区间不完善，请调整后生成规则！')
                return
            }

            this.rulesTable.showMode = true;
            this.rulesTable.canSave = true;
        },

        // 修改总分
        doEditScore() {
            this.dialogObj.visible = true;
            this.dialogObj.module = "score";
            this.dialogObj.title = "修改总分";
            this.dialogObj.width = "45%";
        },

        // 考核结果编辑
        onChangeMark(type, item, index) {
            let value = item[type];
            switch (type) {
                case "min":
                    // 如果大于总分
                    if (value >= this.setTotal) {
                        item[type] = index === 0 ? 0 : this.markResult[index - 1].max + 1;
                        this.$message.warning("请输入合理范围内的值！");
                    } else {
                        // 如果 小于等于上一个的 最大值
                        if (index !== 0 && value <= this.markResult[index - 1].max) {
                            item[type] = this.markResult[index - 1].max + 1;
                            this.$message.warning("请输入合理范围内的值！");
                        }
                    }
                    break;
                case "max":
                    // 如果 大于总分
                    if (value > this.setTotal) {
                        item[type] =
                            index === this.markResult.length - 1
                                ? this.setTotal
                                : this.markResult[index + 1].min - 1;
                        this.$message.warning("请输入合理范围内的值！");
                    } else {
                        // 如果 大于等于下一个的 最小值
                        if (
                            index !== this.markResult.length - 1 &&
                            value >= this.markResult[index + 1].min
                        ) {
                            item[type] = this.markResult[index + 1].min - 1;

                            this.$message.warning("请输入合理范围内的值！");
                        }
                    }
                    break;
            }
        },

        // 点击返回
        doBack(type) {
            switch (type) {
                // 返回重选
                case "backSelect":
                    this.dialogObj.visible = true;
                    this.dialogObj.type = "edit";
                    this.dialogObj.module = "select";
                    this.dialogObj.title = "选择评分项";
                    break;
                // 返回设置
                case "backSetting":
                    this.rulesTable.setting = false;
                    break;
                // 返回修改规则
                case "backEditRules":
                    this.rulesTable.showMode = false;
                    this.rulesTable.canSave = false;
                    break;
                // 返回上一级
                case "backPage":
                    // 设置返回状态
                    this.setIsBack(true);
                    this.$router.replace({
                        path: "/redirect/evaluate-rules",
                    });
            }
        },

        // 最终提交新增
        doSubmit() {
            this.saveLoading = true;
            let params = {
                ruleId: this.routeQuery.ruleId, // 左侧规则表ID
                createUserid: this.userInfo.id, // 创建人id
                createUser: this.userInfo.sname, // 创建人名称
                sname: this.rulesForm.sname, // 规则名称
                code: this.rulesForm.code, // 规则编号
                version: this.rulesForm.version, // 版本号
                remark: this.rulesForm.remark, // 备注
                totalScore: this.sumTotal, // 合计单项总分
                markResult: JSON.parse(JSON.stringify(this.markResult)),
                details: this.rulesTable.tableData, // 详细评分项数据
            };
            this.$refs.rulesForm.validate((valid) => {
                if (valid) {
                    // 如果没建立考核规则
                    if (this.rulesTable.tableData.length === 0) {
                        this.$message.warning("请设置考核规则！");
                        this.resetBtn();
                        return;
                    }

                    // 如果总分不一致
                    if (this.sumTotal !== this.setTotal) {
                        this.$message.warning(
                            "输入的合计总分 不等于 设置总分，请重新设置！"
                        );
                        this.resetBtn();
                        return;
                    }

                    // 如果考核结果最后的 不是总分
                    if (
                        this.markResult.find((x) => parseInt(x.type) === 3).max !==
                        this.setTotal
                    ) {
                        this.$message.warning(
                            "输入的最终考核结果 不等于 设置总分，请重新设置！"
                        );
                        this.resetBtn();
                        return;
                    }

                    // 如果是编辑  传入id
                    if (this.routeQuery.type === "edit") {
                        params.id = this.rulesForm.id;
                    }

                    Api.saveRulesData(params)
                        .then((res) => {
                            this.resetBtn();
                            // 设置返回状态
                            this.setIsBack(true);
                            this.doBack("backPage");
                        })
                        .catch((err) => {
                            this.resetBtn();
                        });
                } else {
                    this.resetBtn();
                }
            });
        },

        // 按钮状态重置
        resetBtn() {
            setTimeout(() => {
                this.saveLoading = false;
            }, 2000);
        },

        // 数据去除空格
        spaceFilter(data) {
            return data.replace(/\s+/, "");
        },
    },
    computed: {
        // 动态列
        activeColumns() {
            let columns = [
                {
                    prop: "typeName",
                    title: "类别",
                    minWidth: 0,
                    width: 120,
                    headerAlign: "center",
                    align: "center",
                },
                {
                    prop: "sname",
                    title: "名称",
                    minWidth: 150,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "content",
                    title: "内容",
                    minWidth: 200,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "standard",
                    title: "考核标准",
                    minWidth: 200,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
            ];
            return columns;
        },

        // 生成的规则列
        rulesColumns() {
            let columns = [
                {
                    prop: "typeName",
                    title: "类别",
                    minWidth: 0,
                    width: 120,
                    headerAlign: "center",
                    align: "center",
                    editRender: { name: "input", attrs: { type: "text" } },
                },
                {
                    prop: "sname",
                    title: "名称",
                    minWidth: 120,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "content",
                    title: "内容",
                    minWidth: 200,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "standard",
                    title: "考核标准",
                    minWidth: 200,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
            ];

            if (this.rulesTable.setting) {
                columns.push({
                    prop: "singleScore",
                    title: "单项满分值",
                    minWidth: 0,
                    width: 120,
                    headerAlign: "center",
                    align: "right",
                    // editRender: { name: "input", attrs: { type: "text" } },
                });
                if (this.rulesTable.showMode) {
                    columns.push({
                        prop: "declareScore",
                        title: "受托单位申报分值",
                        minWidth: 0,
                        width: 140,
                        headerAlign: "center",
                        align: "right",
                        // editRender: { name: "input", attrs: { type: "text" } },
                    });
                    columns.push({
                        prop: "assessScore",
                        title: "审计机关考核分值",
                        minWidth: 0,
                        width: 140,
                        headerAlign: "center",
                        align: "right",
                        // editRender: { name: "input", attrs: { type: "text" } },
                    });
                }
                columns.push({
                    prop: "remark",
                    title: "备注",
                    minWidth: 300,
                    width: 0,
                    headerAlign: "center",
                    align: "center",
                    // editRender: { name: "input", attrs: { type: "text" } },
                });
            }
            return columns;
        },

        // 路由参数
        routeQuery() {
            return this.$route.query;
        },

        // 解析后的 一些参数
        routeInfo() {
            return {
                markObjName: decodeURI(this.routeQuery.markObjName),
                judgeRoleName: decodeURI(this.routeQuery.judgeRoleName),
                beJudgeRoleName: decodeURI(this.routeQuery.beJudgeRoleName),
            };
        },

        // 合计总分
        sumTotal() {
            let arr = this.rulesTable.tableData.map((x) => parseFloat(x.singleScore));
            return arr.sum();
        },

        // 考核结果 文案
        resultText() {
            let str = "提示：考核结果 ";
            this.markResult.map((x) => {
                str = str + `${x.min}-${x.max}分 为${x.title}, `;
            });
            str = str.slice(0, str.length - 2);
            return str;
        },

        // 考核结果区间齐全判断
        isFull() {
            let minArr = this.markResult.map(x => x.min)
            let maxArr = this.markResult.map(x => x.max)
            minArr.shift()
            maxArr.pop()

            let status = true
            // this.markResult.map(x => x.isError = false)
            maxArr.map((x, index) => {
                if (parseFloat(minArr[index]) - parseFloat(x) !== 1) {
                    this.markResult[index + 1].isError = true
                    status = false
                    return
                }
            })
            
            
            return status
        },

        // 个人信息
        ...mapState("user", {
            userInfo: (state) => state.userInfo,
        }),
    },
};
</script>

<style scoped lang="less">
.rules-detail-main {
    height: 100%;
    position: relative;
    background-color: #fff;
    padding: 20px 20px 10px;

    .color-blue {
        color: #256fc8;
        font-style: normal;
    }

    .info-nav {
        line-height: 40px;
        color: #202020;
        font-size: 12px;
        border-bottom: 1px solid #2671cc;

        .info-title {
            font-size: 16px;
            margin-right: 20px;
        }

        .divider {
            background-color: #202020;
            vertical-align: text-top;
        }
    }

    .rules-detail-content {
        height: calc(~"100% - 144px");
        padding-top: 20px;
        overflow-x: hidden;
        overflow-y: auto;
        position: relative;

        .table-content {
            overflow-y: auto;
            height: 100%;
            overflow-x: hidden;
        }
    }

    .is-setting {
        position: relative;
        padding: 0 0 50px;

        .setting-header {
            height: 42px;
            line-height: 42px;
        }

        .table-content {
            height: calc(~"100% - 42px");
        }

        .setting-text {
            font-size: 12px;
            color: #666;
            padding: 10px 0;
            line-height: 20px;
        }

        .setting-score {
            font-size: 14px;
            line-height: 40px;
            color: #202020;

            h3 {
                font-size: 16px;
            }
        }

        .input-width {
            width: 100px;
        }
    }

    .is-onlyRead {
        padding: 0;

        .setting-text {
            line-height: 35px;
            font-size: 14px;
        }

        .show-total {
            font-size: 16px;
            color: #202020;
        }

        .text-border {
            margin-right: 10px;
            border-bottom: 1px solid #666;
            font-size: 14px;
        }

        .is-onlyRead {
            padding: 20px 0;
            line-height: 30px;
        }
    }

    .rules-detail-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #fff;
        z-index: 10;
    }

    .add-dialog {
        /deep/ .el-dialog__body {
            padding-top: 0;
        }

        .info-nav {
            border: none;
        }
    }

    .is-error {
        /deep/ .el-input__inner {
            border: 2px solid #f56c6c;
        }
    }

    /deep/ .el-input-number.is-controls-right .el-input__inner {
        text-align: left;
    }
}

// 按钮特殊处理
.special-btn-groups {
    position: fixed;
    top: 64px;
    right: 9px;
    background-color: #ffffff;
    z-index: 10;
}
</style>
